












import { Component, Vue } from 'vue-property-decorator';
import CardTitle from '@/shared/card/card-title.component.vue';
import MobileHandler from '@/shared/utils/mobile-handler';

@Component({
  components: {
    CardTitle,
  },
})
export default class SkillMapHeader extends Vue {
  isMobile = false;

  onResize() {
    this.isMobile = MobileHandler.isLessThan(768);
  }
}
